import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/common/Button';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1>Page Not Found</h1>
        <p>Sorry, the page you are looking for doesn't exist or has been moved.</p>
        <div className="action-buttons">
          <Button variant="primary" onClick={() => navigate(-1)} icon="fa-arrow-left">
            Go Back
          </Button>
          <Button variant="secondary" onClick={() => navigate('/login')} icon="fa-home">
            Go to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;